export default __webpack_public_path__ + "static/media/6.28988dc9.png";